import './css/range.css'
import './css/compare_fixed.css'
import './libs/header.js';


import { footer, header, reportViewPort, getUserHead } from './libs/common.js'

import initCompareProduct from './libs/compareProduct/index.js'

footer();
header()

initCompareProduct()


setTimeout(() => {
    reportViewPort();
    getUserHead();
}, 1000);
